"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var DividerElement = styled_components_1.default.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top-width: 0;\n  border-right-width: 0;\n  border-bottom-width: ", "px;\n  border-left-width: 0;\n  border-color: ", ";\n  border-bottom-style: ", ";\n  margin-top: ", "rem;\n  margin-bottom: ", "rem;\n  margin-left: 0;\n  margin-right: 0;\n"], ["\n  border-top-width: 0;\n  border-right-width: 0;\n  border-bottom-width: ", "px;\n  border-left-width: 0;\n  border-color: ", ";\n  border-bottom-style: ", ";\n  margin-top: ", "rem;\n  margin-bottom: ", "rem;\n  margin-left: 0;\n  margin-right: 0;\n"])), function (_a) {
    var size = _a.size;
    return size;
}, b2c_theme_1.colors.dividerColor, function (_a) {
    var dividerStyle = _a.dividerStyle;
    return dividerStyle;
}, function (_a) {
    var marginTop = _a.marginTop;
    return marginTop;
}, function (_a) {
    var marginBottom = _a.marginBottom;
    return marginBottom;
});
var Divider = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 1 : _b, _c = _a.dividerStyle, dividerStyle = _c === void 0 ? 'solid' : _c, _d = _a.marginTop, marginTop = _d === void 0 ? 0 : _d, _e = _a.marginBottom, marginBottom = _e === void 0 ? 0 : _e;
    return (react_1.default.createElement(DividerElement, { "data-testid": "divider-element", size: size, dividerStyle: dividerStyle, marginBottom: marginBottom, marginTop: marginTop }));
};
exports.default = Divider;
var templateObject_1;
//# sourceMappingURL=Divider.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Divider/Divider.js
// module id = 1431
// module chunks = 1 2 5 6 14 15 16 17 18 19 20 30 47